import { css } from '@emotion/react';
import { CssVars, FoundationIcon, SemanticColorToken, Type } from '@robinhood/design';

import { AddressType } from 'src/clients/Network/gql/types/address';
import Button from 'src/components/creditApplication/Button';
import Cell from 'src/components/creditApplication/Cell';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import MapThumbnail from 'src/components/creditApplication/MapThumbnail';
import { CREDIT_APPLICATION_PAGE_MAX_WIDTH } from 'src/components/creditApplication/constants/dimensions';

interface IPropsIface {
  onEditAddress: () => void;
  onContinue: () => void;
  address: AddressType;
  loading: boolean;
}

const ResidentialAddressPage = ({ onEditAddress, onContinue, address, loading }: IPropsIface) => {
  return (
    <CreditApplicationPageLayout title='Your residential address' subtitle='Review and confirm your address'>
      <div css={root}>
        <div css={contentContainer}>
          <MapThumbnail
            address={address}
            width={CREDIT_APPLICATION_PAGE_MAX_WIDTH}
            height={400}
            alt='Residential Address'
          />
          <Cell css={cellStyle} onClick={onEditAddress}>
            <div css={editAddressContainer}>
              <FoundationIcon type='Edit12' color={SemanticColorToken.Positive} />
              <Type.Text size='M' isBold color={SemanticColorToken.Positive}>
                Edit residential address
              </Type.Text>
            </div>
          </Cell>
        </div>
        <Button label='Continue' type='button' width='full' onClick={onContinue} state={loading ? 'loading' : false} />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

const contentContainer = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const editAddressContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const cellStyle = css`
  cursor: pointer;

  &:hover {
    background-color: ${CssVars.neutral.bg3};
  }
`;

export default ResidentialAddressPage;
